import { useCreation } from '@euler/utils/hooks';
import { createContext, memo, ReactNode, useContext, useMemo } from 'react';
import { BehaviorSubject } from 'rxjs';

export type SearchContextProps = {
  query$: BehaviorSubject<string>;
};

export const SearchContext = createContext<SearchContextProps>(null as any);

export const useSearchContext = () => {
  return useContext(SearchContext);
};

export const SearchContextProvider = memo(
  ({ children }: { children?: ReactNode }) => {
    const query$ = useCreation(() => new BehaviorSubject<string>(''), []);
    const value = useMemo(() => ({ query$ }), [query$]);
    return (
      <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
    );
  },
);
